export const INITIAL = 'initial';
export const SUCCESS = 'success';
export const ERROR = 'error';
export const PENDING = 'pending';
